<div class="scrollable-table" style="margin: 0;" id="print" *ngIf="group?.length>0">
    <table class="table-wrapper tb-master">
        <thead class="table-header">
            <tr class="table-row">
                <th class="table-col center">No.</th>
                <th class="table-col center">CO Material Code</th>
                <th class="table-col center">CO Material Name</th>
                <!-- <th class="table-col center">UOM</th> -->
                <th class="table-col center">NN.W</th>
            </tr>
        </thead>
        <tbody class="table-body">
            <tr class="table-row" *ngFor="let item of group;let i=index">
                <td class="table-col">{{i+1}}</td>
                <td class="table-col">{{item?.materialRef|docRef:'code'|async}}</td>
                <td class="table-col">{{item?.materialRef|docRef:'name'|async}}</td>
                <!-- <td class="table-col"></td> -->
                <td class="table-col right">
                    {{materials | sumMaterial : 'qty' : item.materialKey | number : '.2-2'}}
                    {{item?.uomRef|docRef:'code'|async}}
                </td>
            </tr>
        </tbody>
    </table>
</div>